module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABWUlEQVQokX3SP2tUURAF8N++XVAWDMTWwkr8DPKwsNNCkkLQQtTCwkbsphXs3oCNTUCExM4EFvxTpdHqfQAxoGhjYyEKidhsZPVa5G1YwtMDF4a5Z+aec2cGpRRzZOZZ3MZxzDBA1cVPI+LtnDuYF2bmddzANiYR8bnLn8IqLuNFRKwdFmbmFdzDtYj4ogeZuYwtbEbEk+F4PD6N+7gaEV8XiHfbtv1W1/Ue1HU9bdt2Cw/atn1XdZ5eRsT3I4+c6bweIiL2sYFbFZYw6VH3A/s9+QlmFaaLEhew3Oc1ImbYHeF3HwEfEZn508FYdiJio7v7VWGYmUs9nR/hYedpHa8hMyucGGGKS9jsKf7Uo2QVowrPsJKZw39IPooPWFNK0TTNzaZpHpdS/O80TXNsHi+u3B2cw3O86n5PZg5wERewHhHvWdjVjnQeK9jDLoqDOZ/EG2xHxB/4Cx9woyx7yKBvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timeicon.png
// module id = I1YU
// module chunks = 1